const state = {
    user: null,
    chips: null,
    token: null,
    eventManage:null,
    eventDetailHideSections: [],
    isOffer: true,
    showBalanceProperty: false,
    userSpinData: null,
};

const getters = {
    isAuthenticated: state => !!state?.user,
    stateUser: state => state?.user,
    chips: state => state?.chips,
    token: state => state?.token,
    eventManage: state => state?.eventManage,
    eventDetailHideSections: state => state?.eventDetailHideSections,
    isOffer: state => state?.isOffer,
    showBalanceProperty: state => state?.showBalanceProperty,
    userSpinData: state => state?.userSpinData,
};

const actions = {
    setUser({ commit }, user) {
        commit('setUser', user);
    },

    setChips({ commit }, chips) {
        commit('setChips', chips);
    },

    setToken({ commit }, token) {
        commit('setToken', token);
    },

    setEventManage({ commit }, token) {
        commit('setEventManage', token);
    },

    seteventDetailHideSections({ commit }, filter) {
        commit('seteventDetailHideSections', filter);
    },

    setIsOffer({ commit }, isOffer) {
        commit('setIsOffer', isOffer);
    },

    setShowBalanceProperty({ commit }, showBalanceProperty) {
        commit('setShowBalanceProperty', showBalanceProperty);
    },

    setUserSpinData({ commit }, userSpinData) {
        commit('setUserSpinData', userSpinData);
    },

};

const mutations = {
    setUser(state, user) {
        state.user = user
    },

    setChips(state, chips) {
        state.chips = chips
    },

    setToken(state, token) {
        state.token = token;
    },

    setEventManage(state, eventManage) {
        state.eventManage = eventManage;
    },

    seteventDetailHideSections(state, eventDetailHideSections) {
        state.eventDetailHideSections = eventDetailHideSections;
    },

    setIsOffer(state, isOffer) {
        state.isOffer = isOffer;
    },

    setShowBalanceProperty(state, showBalanceProperty) {
        state.showBalanceProperty = showBalanceProperty;
    },

    setUserSpinData(state, userSpinData) {
        state.userSpinData = userSpinData;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};